import React, { FC, useState } from "react";

import { useDebounce } from "react-use";
import styled from "styled-components";
import InputBase from "@mui/material/InputBase";

import { SearchIcon } from "@/assets/icons";

type SearchFieldProps = {
    placeholder: string;
    onSearch: (searchWord: string) => void;
};

const SearchFieldContainer = styled.div`
    position: relative;
    z-index: 10;
    background-color: var(--color-white);
    border-radius: var(--radius-10);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
`;

const SearchIconContainer = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 100%;

    svg {
        path {
            fill: var(--color-secondary);
        }
    }
`;

const SearchInputBase = styled(InputBase)`
    width: 100%;

    &.root {
        width: 100%;
        color: inherit;
    }

    .input {
        width: 100%;
        padding-left: 70px;
    }
`;

const SearchField: FC<SearchFieldProps> = ({ placeholder, onSearch }) => {
    const [searchWord, setSearchWord] = useState("");

    useDebounce(
        () => {
            onSearch(searchWord);
        },
        400,
        [searchWord],
    );

    return (
        <SearchFieldContainer className="search">
            <SearchIconContainer className="searchIcon">
                <SearchIcon />
            </SearchIconContainer>
            <SearchInputBase
                classes={{ root: "root", input: "input" }}
                onChange={(e) => setSearchWord(e.target.value)}
                data-testid="search_field-input-search"
                placeholder={placeholder}
                inputProps={{ "aria-label": placeholder, "data-testid": "search_field-input", name: "search" }}
            />
        </SearchFieldContainer>
    );
};

export default SearchField;
